<template>
    <div v-if="filterDateRange"  class="row row-appt-flow">

      <div class="col-date-title col-4 d-flex flex-column justify-content-center">
        <h1 v-if="filterDateRange == 'yesterday'">Yesterday</h1>
        <h1 v-if="filterDateRange == 'oneWk'">1 Week</h1>
        <h1 v-if="filterDateRange == 'oneMo'">1 Month</h1>
        <h3 class="light-weight">
          <span>{{ filterDateRangeTimestamps.start | prettyDateShortTz }}</span>
          <span v-if="filterDateRange !== 'yesterday'"> — {{ filterDateRangeTimestamps.end | prettyDateShortTz }}</span>
        </h3>
      </div> <!-- /.col -->

      <div class="col-chart col-4">
        <stat-pct-whycare 
          :filter-date-range-timestamps="filterDateRangeTimestamps" 
          :filter-primary-provider="filterPrimaryProvider" 
          :filter-secondary-provider="filterSecondaryProvider" 
          :filter-assistant="filterAssistant"
        />
      </div> <!-- /.col -->

    </div> <!-- /.row -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'
import moment from 'moment-timezone';
import StatPctWhycare from '../components/StatPctWhycare.vue'

export default {
  props: ['filterDateRange','filterDateRangeTimestamps', 'filterPrimaryProvider', 'filterSecondaryProvider', 'filterAssistant'],
  components: {
    ListErrors, StatPctWhycare,
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter']),
   
  },
  watch: {
    
  },
  methods: {
    
  },
  mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.row-appt-flow {
  border-top: 1px solid @dark-color;
  border-left: 1px solid @dark-color;

  > div {
    border-bottom: 1px solid @dark-color;
    border-right: 1px solid @dark-color;
    min-height: 150px;
  }
}

.col-date-title {
  border-top: 2px solid @dark-color;
  border-left: 2px solid @dark-color;
  padding: 30px 20px;

  h1, h3 {
    margin: 0;
  }
}

.col-chart {
  padding: 0;
}

</style>
